import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { AuthenticationService } from '../service/authentification.service';
import { catchError } from 'rxjs/operators';
import { engageAuthHeaders } from '../kiwixi/auth-headers';
import { Router } from '@angular/router';
import * as authActions from '../store/actions/auth.actions';
import { SharedAppState } from '../store/app.states';
import { ProfileStoreGuard } from '../guard/profileStore.guard';
import { isAiAccessRequest, isAiEngineUrl } from './ai-engine-request.util';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    access_token: string;
    xBundleRecurring: string;
    private isRefreshing = false;

    /**
     * Constructor
     */
    constructor(
        private _authService: AuthenticationService,
        private store: Store<SharedAppState>,
        private router: Router,
        private profileStoreGuard: ProfileStoreGuard
    ) {
        this.store.select("auth").subscribe(state => {
            this.access_token = state.access_token;
            this.xBundleRecurring = state.xBundleRecurring;
        });
    }

    logout(): void {
        this.profileStoreGuard.resetUserDataLoaded();
        this._authService.logout();
        this.store.dispatch(authActions.logout());
        this.router.navigateByUrl('login');
    }

    addAuthHeader(req: HttpRequest<any>): HttpRequest<any> {
        // Le moteur IA n'accepte que son propre jeton (lié au test) : l'identité Engage ne lui est pas envoyée.
        if (this.access_token && this.xBundleRecurring && !isAiEngineUrl(req.url)) {
            const bundle = JSON.parse(this.xBundleRecurring);
            return req.clone({
                setHeaders: engageAuthHeaders(bundle, this.access_token),
            });
        }
        return req;
    }

    // refreshToken(): Observable<any> {
    //     return this._authService.signInUsingToken();
    // }

    handleResponseError(error, req?: HttpRequest<any>, next?: HttpHandler): Observable<HttpEvent<any>> {
        if (error.status === 400) {

        }

        // Invalid token error
        else if (error.status === 401) {
            if (!this.isRefreshing) {
                this.isRefreshing = true;
                // return this.refreshToken().pipe(
                //     switchMap(() => {
                //         this.isRefreshing = false;
                //         let newReq = this.addAuthHeader(req);
                //         return next.handle(newReq).pipe(
                //             catchError((error) => {
                //                 this.logout();
                //                 return throwError(() => new Error(error));
                //             }),
                //         )
                //     }),
                //     catchError((error) => {
                //         this.logout();
                //         return throwError(() => new Error(error));
                //     }));
            }
        }

        // Access denied error (le refus d'un jeton du moteur IA n'est pas une fin de session Engage)
        else if (error.status === 403 && !isAiAccessRequest(req?.url)) {
            this.logout()
        }

        // Server error
        else if (error.status === 500) {
        }

        // Maintenance error
        else if (error.status === 503) {

        }
        return throwError(error);
    }


    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Request
        let newReq = this.addAuthHeader(req);

        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                return this.handleResponseError(error, req, next);
            })
        );
    }
}
